import { useRef } from 'react';
import { useService } from '@xstate/react';
import debug from 'debug';
import { interpret, State } from 'xstate';
import { machineWatcher } from '../machineDebug';
import { inputGroupMachine } from './index';
import { isInputGroupContextValid, validateInputGroupContext, validateInputGroupContextWithCustom } from './validateInputGroup';
export { isInputGroupContextValid, State, validateInputGroupContext, validateInputGroupContextWithCustom };
const dbg = debug('fsm:inputGroup');
export function useInputGroup(context, services, debug) {
  const serviceRef = useRef(null);
  if (serviceRef.current === null) {
    const machine = inputGroupMachine(services).withContext(context);
    serviceRef.current = interpret(machine).start();
    if (debug) {
      machineWatcher(serviceRef.current, 'inputGroup', dbg);
    }
  }
  const [state, send] = useService(serviceRef.current);
  const {
    inputRefs,
    data
  } = state.context;
  return {
    inputRefs: inputRefs,
    send: send,
    data: data,
    state: state
  };
}